export default __webpack_public_path__ + "static/Blind-angels-tony-video-thumbnail-799d6e88f2fd1c04d3aec2c6b01883c5.png";